import {AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UserService} from '../../services/user.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-list-user-image',
  templateUrl: './list-user-image.component.html',
  styleUrls: ['./list-user-image.component.scss']
})
export class ListUserImageComponent implements OnInit, AfterViewInit, OnDestroy {


  @Input() userIds: number[];
  members: any[];

  constructor(private _elementRef: ElementRef,
              private userService: UserService,
              public http: HttpClient) {
  }

  ngOnInit() {
      this.members = [];
      let idsInLocalStorage = [];
      let localMembers = JSON.parse(localStorage.getItem('members'));
      if ( this.userIds ) {
        for (let i = 0; i < this.userIds.length; i++) {
          let id = this.userIds[i];
          if ( localMembers && localMembers[id] ) {
            this.members.push(localMembers[id]);
            idsInLocalStorage.push(id);
          }
        }

        let theRestOfIds = _.difference(this.userIds,idsInLocalStorage);
        if (theRestOfIds && theRestOfIds.length > 0) {
          this.userService.findByIds(theRestOfIds)
            .subscribe(res => {
              if ( res && res.length > 0) {
                let members = JSON.parse(localStorage.getItem('members'));
                if (!members) {
                  members = {};
                }
                for ( let i = 0; i < res.length; i++) {
                  let user = res[i];
                  this.members.push(user);
                  members[user.id] = user;
                  localStorage.setItem('members', JSON.stringify(members));
                }
              }
            }, err => {
              console.log(err);
            });
        }

      }
  }

  ngOnDestroy(): void {}

  ngAfterViewInit(): void {
  }

}
